module.exports = __webpack_public_path__ + "static/media/app.02ab960e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/hero/app.png
// module id = 499
// module chunks = 0